import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns"
import {MDBCol, MDBRow} from "mdbreact"
import {useCallback} from "react"
import {useDispatch} from "react-redux"
import {
    CustomPrice,
    setDeleteCustomPriceId,
    setSelectedCustomPricingId,
    setSelectedCustomPricingName,
    showAddEditCustomersModal,
    showDeleteModal,
    showManageCustomPricingModal,
    updateCustomPricesActiveStatus,
} from "../../containers/CustomPrices/customPricesSlice"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"
import {hasPermission} from "../Shared/permissionChecker"

const ActiveSwitch = ({customPrice}: {customPrice: CustomPrice}) => {
    const dispatch = useDispatch()
    const roles = useAppSelector((state: RootState) => state.containers.users.roles)
    const selectedRegion = useAppSelector((state: RootState) => state.application.selectedRegion)
    const assignedPermissions = useAppSelector((state: RootState) => state.application.permissions)
    const loggedInUserRole = useAppSelector((state: RootState) => state.application.permissions?.roleId)
    const verifyPermission = (checkPermissions: string[]) => hasPermission(checkPermissions, assignedPermissions)

    const editCustomPrice = (customPricingId: number) => {
        dispatch(showManageCustomPricingModal(true))
        dispatch(setSelectedCustomPricingId(customPricingId))
    }

    const ActiveChange = (e: DropDownListChangeEvent) => {
        dispatch(
            updateCustomPricesActiveStatus(
                selectedRegion?.regionId ?? 0,
                customPrice.customPricingID,
                customPrice.active,
            ),
        )
    }
    const addCustomers = (customPricingId: number) => {
        dispatch(showAddEditCustomersModal(true))
        dispatch(setSelectedCustomPricingId(customPricingId))
        dispatch(setSelectedCustomPricingName(customPrice.customPricingName))
    }

    const valueChange = useCallback(
        (e: DropDownListChangeEvent) => {
            if (customPrice.active) {
                const actionMap: Record<string, () => void> = {
                    "View customers": () => addCustomers(customPrice.customPricingID),
                    "Manage customers": () => addCustomers(customPrice.customPricingID),
                    "View custom price": () => editCustomPrice(customPrice.customPricingID),
                    "Edit custom price": () => editCustomPrice(customPrice.customPricingID),
                    "Delete custom price": () => {
                        dispatch(setDeleteCustomPriceId(customPrice.customPricingID));
                        dispatch(setSelectedCustomPricingName(customPrice.customPricingName));
                        dispatch(showDeleteModal(true));
                    }
                };
                actionMap[e.value]?.();
            };
        },
        [customPrice.active, customPrice.customPricingID, dispatch, editCustomPrice, selectedRegion.regionId],
    )
    return (
        <>
            <MDBRow className="align-items-center mb-3 d-flex justify-content-between">
                <MDBCol className="col-5 ">
                    <DropDownList
                        data={["Active", "Disabled"]}
                        value={customPrice.active ? "Active" : "Disabled"}
                        onChange={ActiveChange}
                        disabled={
                            !verifyPermission(["CustomPricing.Edit"]) ||
                            (roles !== null && loggedInUserRole !== undefined && roles[0].id === loggedInUserRole)
                        }
                    />
                </MDBCol>
                <MDBCol className="col-6">
                    <DropDownList
                        disabled={!customPrice.active}
                        data={[
                            ...(verifyPermission(["CustomPricing.Add"]) ? ["Manage customers"] : ["View customers"]),
                            ...(verifyPermission(["CustomPricing.Edit"])
                                ? ["Edit custom price"]
                                : ["View custom price"]),
                            ...(verifyPermission(["CustomPricing.Delete"]) ? ["Delete custom price"] : []),
                        ]}
                        onChange={valueChange}
                        value={"Actions"}
                    />
                </MDBCol>
            </MDBRow>
        </>
    )
}

export default ActiveSwitch
